import React, { useEffect, useState } from 'react';
import { useLanguage } from '../contexts/LanguageContext';

const Header = () => {
    const { t } = useLanguage();
    const [logoFilter, setLogoFilter] = useState('none');

    useEffect(() => {
        // Función para aplicar el filtro inmediatamente
        const applyLogoFilter = () => {
            const root = document.querySelector(':root');
            const isDark = root?.getAttribute('color-scheme') === 'dark';
            setLogoFilter(isDark ? 'brightness(0) invert(1)' : 'none');
        };

        // Aplicar inmediatamente
        applyLogoFilter();

        // Observer para cambios
        const observer = new MutationObserver(applyLogoFilter);
        observer.observe(document.documentElement, {
            attributes: true,
            attributeFilter: ['color-scheme']
        });

        return () => observer.disconnect();
    }, []);

    return (
        <header id="header" className="mxd-header">
            <div className="mxd-header__logo loading__fade">
                <div className="mxd-logo">
                    <img
                        src="/img/logo.png"
                        alt={t('common.alt_texts.logo')}
                        style={{
                            width: '145px',
                            height: 'auto',
                            display: 'block',
                            maxWidth: '100%',
                            filter: logoFilter,
                            transition: 'filter 0.3s ease'
                        }}
                    />
                </div>
            </div>
            <div className="mxd-header__controls loading__fade">
                <button
                    id="color-switcher"
                    className="mxd-color-switcher"
                    type="button"
                    role="switch"
                    aria-label="light/dark mode"
                    aria-checked="true"
                >
                    <i className="ph-bold ph-moon-stars"></i>
                </button>
                <a
                    className="btn btn-anim btn-default btn-mobile-icon btn-outline slide-right-up"
                    href="https://wa.me/34610683948"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    <span className="btn-caption">{t('navigation.contact')}</span>
                    <i className="ph-bold ph-arrow-up-right"></i>
                </a>
            </div>
        </header>
    );
};

export default Header;
